var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128",
    id: "person",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 41,
    r: 18,
    stroke: "#1F1F1F",
    strokeWidth: 7,
    transform: "rotate(-90 64 41)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: "M26 88.2481C26 97.4999 33.5001 105 42.7519 105H85.1912C94.4745 105 102 97.4745 102 88.1912V88.1912C102 77.3621 91.9099 69.3587 81.3651 71.8237L69.0359 74.7059C65.3957 75.5569 61.607 75.5457 57.9718 74.6732L46.6614 71.9587C36.1273 69.4306 26 77.4149 26 88.2481V88.2481Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.9a7a7eab94cf9b2e96cff67998d5de8b.svg";
export { ForwardRef as ReactComponent };